import { useQuery } from "@tanstack/react-query";
import { api } from "@/src/core/api/client";
import type { ICompanyDetails } from "../types";

const COMPANY_DETAILS_URL = process.env.NEXT_PUBLIC_TRAVELA_DETAILS;

const companyKeys = {
  details: () => ["company", "details"] as const,
};

/** Raw call (a static JSON file, not a backend). Throws an ApiError on failure. */
export const companyApi = {
  async getDetails(): Promise<ICompanyDetails> {
    const { data } = await api.external.get<ICompanyDetails>(
      `${COMPANY_DETAILS_URL}`,
    );
    return data;
  },
};

/** About/policies/contact; rarely changes, so cached for 5 minutes. */
export const useCompanyDetailsQuery = () =>
  useQuery({
    queryKey: companyKeys.details(),
    queryFn: companyApi.getDetails,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
